import { createConfirmation } from "react-confirm";
import TeamModal from "./TeamModal";

export const showTeamModal = createConfirmation(TeamModal);
